import { useCallback } from 'react'

import { useWebSocketApi } from '@e3dc-react/shell/Hooks'
import { SocketStateModel } from '@e3dc-react/shell/Hooks/use-websocket-api'
import { HardwareTestResultModel } from '../models'
import { TestResultDto } from '../dto/hardware-test-result.dto'
import fromDtoToTestResultModelTransformer from '../transformers/from-dto-to-test-result.transformers'

const SERVICE_ID = '[HARDWARE RUNNING TEST]'

interface UseRunningHardwareTestReturnType {
  runningHardwareTestResult: SocketStateModel<HardwareTestResultModel>
  finishTesting: () => void
}

/** Hook to get information about running hardware test of selected system. */
export const useRunningHardwareTest = (serialNumber?: string, testRunId?: string): UseRunningHardwareTestReturnType => {
  const resourcePath = `hardware-tests/storages/${serialNumber}/tests/runs/${testRunId}/ws`

  const { socketState, resetWebsocketToInitial } = useWebSocketApi<HardwareTestResultModel, TestResultDto>({
    endpoint: process.env.REACT_APP_HARDWARE_TESTS_ENDPOINT ?? '',
    apiResourcePath: resourcePath,
    loggerKey: SERVICE_ID,
    transformer: fromDtoToTestResultModelTransformer,
    doNotInitialize: !serialNumber || !testRunId,
    dependencies: [serialNumber, testRunId],
  })

  const finishTesting = useCallback(() => {
    resetWebsocketToInitial()
  }, [resetWebsocketToInitial])

  return { runningHardwareTestResult: socketState, finishTesting }
}
